import { useFormik } from "formik";
import { useEffect, useState } from "react";
import useEditData from "../../../hooks/useEditData";
import useAddData from "../../../hooks/useAddData";
import { CancelButton, SubmitButton } from "../../../utils/Button";
import FileDisplay from "../../../utils/FileDisplay";
import { NuDate, NuInput, NuTextArea, NuUpload } from "../../../utils/Inputs";
import FormikSelectTwo from "../../../utils/Select";
import { handleKeyDown, ScreenClose } from "../../../utils/OtherFunctions";
import { CloseIcon } from "../../../assets/icons";

export default function CreateOrEdit({
  data,
  visible,
  onClose,
  refreshData,
  metaData=[],
  satusData = [],
  id,
  getCompletion = () => {},
}) {
  const { isCreateLoading, addData } = useAddData();
  const { isEditLoading, editData } = useEditData();
  const [selectedFile, setSelectedFile] = useState(null);
  const [filePathList, setFilePathList] = useState([]);
  const [removefilePathList, setRemoveFilePathList] = useState([]);
  const [createNew, setCreateNew] = useState({
    task: "",
    frequency_name: "",
    status_name: "",
    comments: "",
    file_path:"",
    completion_date:""

  });
  useEffect(() => {
    setCreateNew({
      task: data?.task,
      frequency_name: data?.frequency_name,
      status_name: data?.status_id,
      comments: data?.comments,
      completion_date:data?.completion_date
    });
    if(data?.file_path !== null){
      setFilePathList(data?.file_path)
      setRemoveFilePathList(data?.file_path)
    }
  }, [data]);

  function handleImageChange(e) {
    const files = Array.from(e.target.files);
    setSelectedFile(files);
  }

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit:  async (value, { resetForm }) => {
      if (data?.id) {
        if(removefilePathList){
          let finalArr = removefilePathList.filter(items=>  !filePathList.includes(items) )
          value.files_to_remove = finalArr.map(item=>item.replace(window.WEB_APP_API_URL, "localhost"));
        }else{
          value.files_to_remove = []
        }
        let formdata = new FormData();
        if(selectedFile){
          selectedFile.forEach((file) => {
            formdata.append("attachment_artifact", file);
          });
        }else{
          formdata.append("attachment_artifact", selectedFile);
        }
        formdata.append("maintenance_data", JSON.stringify(value));
        await ScreenClose({ link: "Maintenance", id: data.id });
        await editData({
          url: `/Maintenance/${data.id}/`,
          value: formdata,
          resetForm: resetForm,
          onClose: onClose,
          getData: refreshData,
          hasFile: true,
          setSelectedFile: setSelectedFile,
          otherFunction: getCompletion,
        });
      } else {
        let formdata = new FormData();
        if(selectedFile){
          selectedFile.forEach((file) => {
            formdata.append("attachment_artifact", file);
          });
        }else{
          formdata.append("attachment_artifact", selectedFile);
        }
        formdata.append("maintenance_data", JSON.stringify(value));
        addData({
          url: `/Maintenance/standard/${id}/`,
          value: formdata,
          resetForm: resetForm,
          onClose: onClose,
          getData: refreshData,
          otherFunction: getCompletion,
        });
      }
    },
  });
  function UpdateAttachmentList(item) {
    let filterList = filePathList.filter((itemList) => itemList !== item);
    setFilePathList(filterList);
  }

  const resetClose = () => {
    if(data){
      ScreenClose({ link: "Maintenance", id: data.id });
    }
    setSelectedFile(null)
    formik.resetForm();
    onClose();
  };

  if (!visible) return null;

  return (
    <>
      <div
        id="modal"
        className="bg-black bg-opacity-30 fixed z-10 inset-0 backdrop-blur-sm 
        flex justify-center items-center "
      >
        <div className="bg-white mt-12 p-2 rounded-xl w-6/12">
          <div className="flex items-start justify-between px-5 py-2  rounded-t">
            <h3 className="text-base 2xl:text-lg font-semibold">
              {data ? "Edit" : "New"}
            </h3>
            <span
              className="h-6 w-6 text-2xl block cursor-pointer"
              onClick={resetClose}
            >
              <CloseIcon />
            </span>
          </div>
          <form onSubmit={formik.handleSubmit} onKeyDown={handleKeyDown}>
            <div className="relative   max-h-[calc(100vh-180px)] overflow-y-auto  flex flex-wrap justify-between text-left">
              
            <NuInput
                formik={formik}
                name="task"
                label="Task Name"
                width="w-full"
                placeholder="Task Name"
              />

              <FormikSelectTwo
                formik={formik}
                name="frequency_name"
                label="Frequency"
                width="w-1/2"
                placeholder="Select Frequency"
                Options={metaData}
                zindex={12}
              />

              <NuDate
                formik={formik}
                name="completion_date"
                label="Completion Date"
                width="w-1/2"
                placeholder="Completion Date"
              />

              <NuTextArea
                formik={formik}
                name="comments"
                label="Comments"
                width="w-full"
                placeholder="Enter your Comments"
              />

              <NuUpload
                label="Artefact"
                width="w-1/2"
                onChange={handleImageChange}
                multiple={true}
              />

              <FormikSelectTwo
                formik={formik}
                name="status_name"
                label="Status"
                width="w-1/2"
                placeholder="Select Status"
                Options={satusData}
                zindex={12}
              />
              <div className=" w-full flex flex-wrap ">
                {data?.file_path &&
                  filePathList.map((i) => {
                    return (
                      <div className=" m-1 my-3">
                        <div className=" relative">
                          <div
                            className=" w-4 h-4 rounded bg-slate-400 absolute text-white cursor-pointer font-bold flex justify-center items-center  -top-2 right-2 z-10"
                            onClick={() => UpdateAttachmentList(i)}
                          >
                            -
                          </div>
                          <FileDisplay
                            data={i}
                            view={true}
                            height={"45px"}
                            width={"45px"}
                          />
                        </div>
                      </div>
                    );
                  })}
              </div>
              <div className=" w-full flex items-center px-3 justify-end pb-6 rounded-b">
                <CancelButton
                  onClose={resetClose}
                  isLoading={isCreateLoading || isEditLoading}
                />
                <SubmitButton isLoading={isCreateLoading || isEditLoading} />
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
